import { useQuery } from '@apollo/client';
import { Query, QueryGetVisitorGroupsForTenantArgs } from 'graphql/generated/graphqlTypes';
import { GET_ALL_VISITORS_GROUPS } from 'graphql/v2/queries';
import { BaseHookProps } from 'hooks/shared/types';
import useTranslation from 'hooks/useTranslation/useTranslation';
import { useEffect, useMemo } from 'react';
import { filterHiddenVisitorGroups } from 'v2/utils/visitorGroupOrigin';

const useVisitorsGroups = ({ handleFetchError }: BaseHookProps) => {
  const { translation } = useTranslation();

  const {
    loading: allVisitorGroupsLoading,
    error: allVisitorGroupsError,
    data: allVisitorGroupsData,
    refetch: refetchAllVisitorGroups
  } = useQuery<Pick<Query, 'getVisitorGroupsForTenant'>, QueryGetVisitorGroupsForTenantArgs>(GET_ALL_VISITORS_GROUPS);

  useEffect(() => {
    if (allVisitorGroupsError) {
      handleFetchError(translation.user_groups_error_fetching);
      console.error(allVisitorGroupsError);
    }
  }, [allVisitorGroupsError]);

  const allVisitorGroups = useMemo(
    () => filterHiddenVisitorGroups(allVisitorGroupsData?.getVisitorGroupsForTenant ?? []),
    [allVisitorGroupsData]
  );

  return {
    allVisitorGroups,
    loadingAllVisitorGroups: allVisitorGroupsLoading && !allVisitorGroupsData,
    hasVisitorGroupsFetchError: Boolean(allVisitorGroupsError),
    retryFetchingVisitorGroups: () => refetchAllVisitorGroups()
  };
};

export default useVisitorsGroups;
